import { Tour, TourStep } from "@tour-kit/react";
import { useRegisteredTours } from "../tours/registeredTours.state";

const RegisteredTours = () => {
  const tours = useRegisteredTours();

  return (
    <>
      {tours.map((tour) => (
        <Tour key={tour.id} id={tour.id}>
          {tour.steps.map((step) => (
            <TourStep key={step.id} {...step} />
          ))}
        </Tour>
      ))}
    </>
  );
};

export default RegisteredTours;
